import {
  createBaseQuery,
  createServerSideRequestOption,
  getBaseUrl,
} from "@/redux/config";
import { createApi } from "@reduxjs/toolkit/query/react";

export const getAvailableBankProviderConfigs = async ({
  companyId,
  serviceId,
  request,
}: {
  companyId: number;
  serviceId: number;
  request: Request;
}) => {
  return await createServerSideRequestOption({
    url: `${getBaseUrl()}/api/v1/c/${companyId}/services/${serviceId}/bank-providers/available-providers`,
    request: request,
    method: "GET",
  });
};

export const getBankProviderConfigs = async ({
  companyId,
  serviceId,
  request,
}: {
  companyId: number;
  serviceId: number;
  request: Request;
}) => {
  return await createServerSideRequestOption({
    url: `${getBaseUrl()}/api/v1/c/${companyId}/services/${serviceId}/bank-providers`,
    request: request,
    method: "GET",
  });
};

export const bankProviderConfigsApi = createApi({
  reducerPath: "bankProviderConfigsApi",
  baseQuery: createBaseQuery("/c/"),
  tagTypes: ["bankProviderConfigs"],
  endpoints: (build) => ({
    loadAvailableProviders: build.query<
      ProviderOption[],
      { companyId: number; serviceId: number }
    >({
      query: ({ companyId, serviceId }) => ({
        url: `/${companyId}/services/${serviceId}/bank-providers/available-providers`,
        method: "GET",
      }),
    }),
    listConfigs: build.query<
      BankProviderConfig[],
      { companyId: number; serviceId: number }
    >({
      query: ({ companyId, serviceId }) => ({
        url: `/${companyId}/services/${serviceId}/bank-providers`,
        method: "GET",
      }),
      providesTags: ["bankProviderConfigs"],
    }),
    createConfig: build.mutation<
      BankProviderConfig[],
      { companyId: number; serviceId: number; data: BankProviderConfigData }
    >({
      query: ({ companyId, serviceId, data }) => ({
        url: `/${companyId}/services/${serviceId}/bank-providers`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["bankProviderConfigs"],
    }),
    editConfig: build.mutation<
      BankProviderConfig[],
      {
        companyId: number;
        serviceId: number;
        data: BankProviderConfigData;
      }
    >({
      query: ({ companyId, serviceId, data }) => ({
        url: `/${companyId}/services/${serviceId}/bank-providers`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["bankProviderConfigs"],
    }),
  }),
});
